import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DirectionService } from '../../direction.service';
import { AuthService } from 'src/app/auth/auth.service';
import { DialogService } from 'src/app/dialog/dialog.service';

import { OrdersService } from 'src/app/other-pages/my-orders/orders-service';
import { PHOrdersService } from 'src/app/super-management/ph-manigment/ph-orders-service';
import { DataSharingService } from 'src/app/main-section/data-shering-service/data-sharing.service';
import { set } from 'lodash';


@Component({
  selector: 'app-delete-order',
  templateUrl: './delete-order.component.html',
  styleUrls: ['./delete-order.component.css'],
  host: {
    class: 'fill-screen-modal-phone'
  }
})
export class DeleteOrderComponent implements OnInit, OnDestroy {
  isRTL: boolean = true;
  private directionSubscription: Subscription;
  isDarkMode: boolean = false;
  isLoading: boolean = false;
  isLoadingUpdates = false;

  userId: string;
  userIsAuthenticated = false;
  private authStatusSub: Subscription;

  order: any;
  isSu: boolean = false;
  orderType: 'ph' | null = null;

  constructor(
    private directionService: DirectionService,
    private authService: AuthService,
    private dialogService: DialogService,
    private ordersService: OrdersService,
    private phOrdersService: PHOrdersService,
    private dataSharingService: DataSharingService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.order = data.order;
    this.isSu = data.isSu ?? false;
    this.orderType = data.orderType ?? null;
  }

  async ngOnInit() {
    this.isLoading = true;
    this.directionSubscription = this.directionService.direction$.subscribe(direction => {
      this.isRTL = direction === 'rtl';
    });

    this.directionService.isDarkMode$.subscribe(isDarkMode => {
      this.isDarkMode = isDarkMode;
    });

    this.userId = this.authService.getUserId();
    this.userIsAuthenticated = this.authService.getIsAuth();
    this.authStatusSub = this.authService
      .getAuthStatusListener()
      .subscribe(isAuthenticated => {
        this.userIsAuthenticated = isAuthenticated;
        this.userId = this.authService.getUserId();
      });

    this.isLoading = false;
  }

  closeDeleteOrderDialog() {
    this.dialogService.onCloseDeleteOrderDialog();
  }

  /** express כולל בקשת תשלום SU (OrderExpress בלי branch). */
  private resolveDeleteService(order: any): 'e' | 'p' {
    if (order?.branchID?.is_express) {
      return 'e';
    }
    const fp = order?.fix_products_order;
    if (fp && typeof fp === 'object' && fp.isEmptyOrder === true) {
      return 'e';
    }
    if (
      fp &&
      typeof fp === 'string' &&
      order?.is_only_fix_products_in_order === true &&
      !order?.branchID &&
      !order?.printerID
    ) {
      return 'e';
    }
    return 'p';
  }

  onDeleteOrder(
    order: any,
  ) {
    const orderId = order._id;
    this.isLoadingUpdates = true;

    if (this.orderType === 'ph') {
      this.phOrdersService.cancelOrder(orderId).subscribe(() => {
        this.phOrdersService.notifyOrderUpdated();
        this.ordersService.notifyOrderUpdated();
        this.dataSharingService.notifyPendingOrderDecrement();
        setTimeout(() => {
          this.dialogService.onCloseDeleteOrderDialog();
        }, 500);
      }, () => {
        this.isLoadingUpdates = false;
      });
      return;
    }

    const userId = order.userId ?? order.userID;
    const service = this.resolveDeleteService(order);
    this.ordersService.deleteOrder(service, userId, orderId, this.isSu).subscribe(() => {
      this.ordersService.notifyOrderUpdated();
      this.dataSharingService.notifyPendingOrderDecrement();
      setTimeout(() => {
        this.dialogService.onCloseDeleteOrderDialog();
      }, 500);
    }, () => {
      this.isLoadingUpdates = false;
    });
  }

  ngOnDestroy() {
    if (this.directionSubscription) {
      this.directionSubscription.unsubscribe();
    }
    if (this.authStatusSub) {
      this.authStatusSub.unsubscribe();
    }
  }

  // ===============
}
